<div class="inbuilt-filter-block">
    <!-- <div class="filter-block"> -->
        <div class="data-filter-block">
            <p (click)=" tabChange('Product_Variant');" [ngClass]="{'active': selectedTab == 'Product_Variant'}">
                Product Variant</p>
            <p (click)="tabChange('Raw_Material');" [ngClass]="{'active': selectedTab == 'Raw_Material'}">Raw
                Material</p>
            <p (click)="tabChange('Generic_Group');" [ngClass]="{'active': selectedTab == 'Generic_Group'}">Generic
                Group</p>
        </div>

        <div class="filter-block">
            <p>Click to View: <span class="custom-highlight-link" (click)="viewTypeChange('All')">All</span>
               | 
                <span class="custom-highlight-link" (click)="viewTypeChange('ModifiedInLast7Days')">Modified in the last
                    7 days</span>
            </p>
        </div>
    <!-- </div> -->

    <ng-container *ngIf="compGuidelinesList?.id">

        <div class="guideline-block" (click)="getAttachments()">
           <div>
             <span class="fa fa-fw fa-exclamation-circle fa-lg WarningIconRed"></span>
            <span class=" custom-highlight-link m-0">
                Compatibility Guidelines
            </span>
            </div>
            <span class="italic-font">
                Last uploaded {{compGuidelinesList?.createdOn | dateFormatter: 'dd MMM yyyy'}}
            </span>
        </div>
    </ng-container>
</div>

<app-custom-grid-filter class="csmart-home-pg" [filterId]="filterId" [placeHolder]="placeHolders[selectedTab]" [advancedFilterAllow]="true"
    [manuFacturingPlantsList]="manufacturingPlants" [wareHouseLocationsList]="warehouseLocations"
    (filterCustomData)="filterCustomData($event)"></app-custom-grid-filter>

@if(!lodingLable && viewType == 'ModifiedInLast7Days' && data.data?.length == 0) {
<div class="grid-empty-seven-days">
    <p class="txt-center">
        <span>Switch to</span>
        <span class="custom-highlight-link" (click)="viewTypeChange('All')"> View All</span>
    </p>
    <p class="msg">
        Now viewing Generic Group modified in the last 7 days.

    </p>
</div>

}

<ng-container *ngIf="lodingLable">
    <div class="txt-center">

        <kendo-loader [themeColor]="'dark'" [type]="'pulsing'" [size]="'small'">
        </kendo-loader>
        <br />
        {{lodingLable}}

    </div>
</ng-container>

<ng-container *ngIf="!lodingLable">

    
    @if((!isAdvancedFilter && data.data?.length == 0) || 
    (isAdvancedFilter && viewType == 'ModifiedInLast7Days' && data.data?.length == 0 ))   
    {
        
    <div class="empty-grid-msg-block" *ngIf="data.data?.length == 0">
        <div class="block">
            Please select a filter criteria and press search button
        </div>
    </div>


    }
@else {
        
    <ng-container *ngIf=" selectedTab == 'Product_Variant'">

        <kendo-grid  class="mt-10" [data]="data_productVariant" [sortable]="true" [resizable]="true"
        (sortChange)="onSortChange($event)" [sort]="orderBy_Direction">
            <kendo-grid-column title="product variant" field="materialName">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <ng-container *ngIf="dataItem.materialName">
                        <a class="a-request" [routerLink]="['/Material-Details', dataItem.materialName]">
                            {{ dataItem.materialName}} [{{dataItem.revision | number}}]
                        </a>
                    </ng-container><br />
                    <span class="StatusLabel" [ngClass]="{'released':true}"
                        *ngIf="dataItem.state">{{dataItem.state}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="technical name" field="technicalName">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <ng-container *ngIf="dataItem.technicalName">
                        <b>{{ dataItem.technicalName}} <br/> {{dataItem.rebrand? 'Rebrand':'-' }}</b>
                    </ng-container><br /> 
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="product category" field="productCategory"></kendo-grid-column>
            <kendo-grid-column title="type" field="productType"></kendo-grid-column>
            <kendo-grid-column title="material code" field="materialCodeDetails" [sortable]="false">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span [innerHTML]="dataItem.materialCodeDetails"> </span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="last modified" field="lastModifiedDate">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{ dataItem.lastModifiedDate | dateFormatter: 'dd MMM yyyy'}}
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
        <app-custom-pager [pageSize]="pageSize" [skip]="pageStartIndex" [total]="data.total"
            (pageChange)="pageChange($event)"></app-custom-pager>


    </ng-container>

    <ng-container *ngIf=" selectedTab == 'Raw_Material'">

        <kendo-grid  class="mt-10" [data]="data_rawMaterial" [sortable]="true" [resizable]="true"
        (sortChange)="onSortChange($event)" [sort]="orderBy_Direction" >
            <kendo-grid-column title="RAW MATERIAL" field="materialName">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <ng-container *ngIf="dataItem.materialName">
                        <a class="a-request" [routerLink]="['/Material-Details', dataItem.materialName]"> 
                            {{ dataItem.materialName}} [{{dataItem.revision | number}}]
                        </a>
                    </ng-container><br />
                    <span class="StatusLabel" [ngClass]="{'released':true}"
                        *ngIf="dataItem.state">{{dataItem.state}}</span>
                </ng-template>  
            </kendo-grid-column>
            <kendo-grid-column title="PREFERRED NAME" field="preferredName">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <ng-container *ngIf="dataItem.preferredName">
                        <b>{{ dataItem.preferredName}} <br/> {{dataItem.rebrand? dataItem.rebrand:'-' }}</b>
                    </ng-container><br /> 
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Product category" field="productCategory"></kendo-grid-column>
            <kendo-grid-column title="type" field="productType"></kendo-grid-column>
            <kendo-grid-column [class]="'text-center'" title="material code" field="materialCodeDetails" [sortable]="false">            
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span [innerHTML]="dataItem.materialCodeDetails"> </span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="last modified" field="lastModifiedDate" >
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{ dataItem.lastModifiedDate | dateFormatter: 'dd MMM yyyy'}}
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
        <app-custom-pager [pageSize]="pageSize" [skip]="pageStartIndex" [total]="data.total"
            (pageChange)="pageChange($event)"></app-custom-pager>
    </ng-container>

    <ng-container *ngIf=" selectedTab == 'Generic_Group'">

        @if(data_genericGroup.length !== 0) {
        <kendo-grid  class="mt-10" [data]="data_genericGroup" [sortable]="true" [resizable]="true" 
        (sortChange)="onSortChange($event)"
        [sort]="orderBy_Direction"
        >
            <kendo-grid-column title="generic group" field="materialName">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <ng-container *ngIf="dataItem.materialName">
                        <a class="a-request" [routerLink]="['/Material-Details', dataItem.materialName]">
                            {{ dataItem.materialName}} [{{dataItem.revision | number}}]
                        </a>
                    </ng-container><br />
                    <span class="StatusLabel" [ngClass]="{'released':true}"
                        *ngIf="dataItem.state">{{dataItem.state}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="technical name" field="technicalName">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <ng-container *ngIf="dataItem.technicalName">
                       <b>{{ dataItem.technicalName}} <br/> {{dataItem.rebrand? dataItem.rebrand:'-' }}</b> 
                    </ng-container><br /> 
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="product category" field="productCategory"></kendo-grid-column>
            <kendo-grid-column title="type" field="productType"></kendo-grid-column>
            <kendo-grid-column title="material code" field="materialCodeDetails" [sortable]="false">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span [innerHTML]="dataItem.materialCodeDetails"> </span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="last modified" field="lastModifiedDate">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{ dataItem.lastModifiedDate | dateFormatter: 'dd MMM yyyy'}}
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
        <app-custom-pager [pageSize]="pageSize" [skip]="pageStartIndex" [total]="data.total"
            (pageChange)="pageChange($event)"></app-custom-pager>
        }

    </ng-container>

    } 


</ng-container>

<!-- <div *ngIf="data.length > 0">
    <kendo-grid [height]="420" class="mt-10" [data]="data" [sortable]="true" [resizable]="true">
        <kendo-grid-column title="product variant" field="productVariant"></kendo-grid-column>
        <kendo-grid-column title="technical name" field="technicalName"></kendo-grid-column>
        <kendo-grid-column title="product category" field="productCategory"></kendo-grid-column>
        <kendo-grid-column title="type" field="type"></kendo-grid-column>
        <kendo-grid-column title="material code" field="matericalCode" [sortable]="false"></kendo-grid-column>
        <kendo-grid-column title="last modified" field="lastModified" [sortable]="false">
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem.lastModified | dateFormatter: 'dd MM yyyy'}}
            </ng-template>
        </kendo-grid-column>
    </kendo-grid>
</div> -->